export const WbTheme = {
  colors: {
    ['slate-gray']: '#424B50',
  },
  ['text-slate-gray']: 'color:#424B50',
};
